import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { TutorialButton } from '@ro-components/Tutorial';

export const mapTutorial = (id, buttonText) => [
  {
    element: '.map_shortcut',
    intro: 'Opcje mapy również oferują możliwość utworzenia skrótu.'
  },
  {
    element: '.map_theme',
    intro: `Tutaj możesz wybrać rodzaj mapy. ${ReactDOMServer.renderToStaticMarkup(
      <TutorialButton id={id} text={buttonText} />
    )}`
  }
];
